import styles from '@/components/elements/buttons/CardButton/CardButton.module.scss'
import Button from 'react-bootstrap/Button'
import LinkButton from '@/components/elements/buttons/LinkButton'

interface Props {
  label: string
  href?: string
  targetBlank?: boolean
  className?: string
}

const CardButton = ({ label, href, targetBlank = false, className = '' }: Props) => {
  return (
    <div className={`${styles.root} ${className}`}>
      {href !== undefined ? (
        <LinkButton href={href} target={targetBlank ? '_blank' : undefined}>
          {label}
        </LinkButton>
      ) : (
        <Button>{label}</Button>
      )}
    </div>
  )
}

export default CardButton
